export default __webpack_public_path__ + "static/media/Leggings of the Shivering Stars.2ded22a4.jpg";